import {Pipe, PipeTransform} from '@angular/core';
import {RefData} from '../../../_models/ref.data.model';

@Pipe({
  name: 'programGuide'
})
export class ProgramGuidePipe implements PipeTransform {

  transform(programName: string, refData: RefData): string {
    return refData.programs.find(item => item.name === programName).guidelinesUrl;
  }

}
